var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.986 10.5c-.167 0-.332-.032-.485-.095a1.172 1.172 0 01-.398-.268L1.096 4.943a.812.812 0 01-.218-.618.836.836 0 01.317-.58 1 1 0 01.672-.214c.246.012.477.111.644.276L6.89 8.35a.128.128 0 00.043.03.138.138 0 00.148-.03l4.38-4.542c.08-.088.18-.16.29-.212a1.013 1.013 0 011.054.12.875.875 0 01.226.27.802.802 0 01-.155.958L7.87 10.135c-.111.114-.247.206-.4.27a1.275 1.275 0 01-.484.095z"
  })));
}

export default SvgSelectDownArrow;